<template>
    <div>
        <base-crud
            :ref="table"
            :crudName="crudName"
            :newText="newText"
            :table="table"
            :columns="columns"
            :options="options"
            :endPoint="endPoint"
            :enableAdd="false"
            :enableEdit="false"
            :enableDelete="false"
            :enableView="false"
            :dataForm="dataForm"
            :detailUrl="detailUrl"
            :extra="extra"
            @moderate="moderate"
        ></base-crud>
    </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
    data() {
        return {
            crudName: "Requisições de Acesso",
            newText: "",
            table: "requestAccessTable",
            columns: [
                "id",
                "person_name",
                "company_name",
                "phone",
                "email",
                'moderate',
                "actions"
            ],
            tableData: ["id", "person_name", "company_name", "phone", "email", 'moderate'],
            options: {
                filterByColumn: true,
                debounce: 1000,
                sortable: [
                    "id",
                    "person_name",
                    "company_name",
                    "phone",
                    "email",
                    'moderate'
                ],
                filterable: [
                    "id",
                    "person_name",
                    "company_name",
                    "phone",
                    "email",
                ],
                pagination: { chunk: 10, dropdown: false, nav: "scroll" },
                perPage: 10,
                perPageValues: [10, 25, 50, 100],
                headings: {
                    id: "#",

                    person_name: "Nome do Requisitante",
                    company_name: "Nome da Empresa",
                    phone: "Telefone",
                    email: "E-mail",
                    moderate: "Status",

                    actions: "Ações"
                },
                templates: {
                    moderate(h, row){
                        if(row.moderate == 1){
                            return <span class="badge badge-success">Aceito</span>
                        } else if(row.moderate == 0){
                            return <span class="badge badge-danger">Negado</span>
                        } else {
                            return <span class="badge badge-warning">Aguardando</span>
                        }
                    }
                },
                requestFunction: function(data) {
                    let requestData = {};

                    let query = this.$parent.$parent.query(data.query);
                    requestData.params = data;
                    requestData.params.query = "";
                    requestData.params.with = [""];

                    return this.$http
                        .get(this.url + "?" + query, requestData)
                        .catch(
                            function(e) {
                                this.dispatch("error", e);
                            }.bind(this)
                        );
                }
            },
            extra: [
                {
                    id: 1,
                    label: "",
                    class: "btn btn-crud edit",
                    title: "Moderar",
                    name: "moderate",
                    icon: "fas fa-user-check"
                },
            ],
            endPoint: "requestaccess/",
            detailUrl: "requestAccess",
            dataForm: {}
        };
    },
    methods: {
        moderate(props){
            this.$router.push('requestAccess/' + props.row.id)
        },
        query: function(query) {
            let columns = {
                id: "id",
                person_name: "person_name",
                company_name: "company_name",
                phone: "phone",
                email: "email"
            };
            let filters = "";
            $.each(query, function(index, value) {
                filters += columns[index] + "=" + value + "&";
            });

            return filters;
        }
    },
    components: {
        BaseCrud
    }
};
</script>


// WEBPACK FOOTER //
// src/components/RequestAccess/Crud.vue